import { render, staticRenderFns } from "./postPoneCast.vue?vue&type=template&id=56d157d6&"
import script from "./postPoneCast.vue?vue&type=script&lang=js&"
export * from "./postPoneCast.vue?vue&type=script&lang=js&"
import style0 from "./postPoneCast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports